import React, { ChangeEvent } from 'react';
import { OrderClItem, LensProduct } from '../types';

type LensDataFormProps = {
  eyeType: 'right' | 'left';
  isLensOrdered: boolean;
  setIsLensOrdered: (ordered: boolean) => void;
  lens: OrderClItem;
  setLens: (data: OrderClItem) => void;
  stockOut?: string;
  qtyMax: number;
  productId: number | undefined;
  isAstigma: boolean;
  products: LensProduct[];
}

type LensSelectProps = {
  label: string;
  options: string[];
  value: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}

export const LensSelect: React.FC<LensSelectProps> = ({label, options, value, onChange}) => (
  <li className="select-list__item">
    <span>{label}</span>
    <div className="select-custom">
      <select value={value} onChange={onChange}>
        <option value="" hidden>--.-</option>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  </li>
)

export const LensDataForm: React.FC<LensDataFormProps> = ({
  eyeType,
  isLensOrdered,
  setIsLensOrdered,
  lens,
  setLens,
  stockOut,
  qtyMax,
  productId,
  isAstigma,
  products
}) => {
  const getProductById = (productId: number | undefined): LensProduct | undefined => {
    return products.find(product => product.id === productId);
  };

  const fcOptions: string[] = Array.from({ length: (47.00 - 39.00) / 0.50 + 1 }, (_, index) => 39.00 + (0.50 * index))
  .map(n => n.toFixed(2)).filter(fc => {
    if(isLensOrdered) {
      return !(lens.tp === "-7.00" && fc === "39.00")
      && !(lens.tp === "-7.50" && ["39.00", "39.50"].includes(fc))
      && !(lens.tp === "-8.00" && ["39.00", "39.50", "40.00"].includes(fc))
    }
    return true;
  });
  const tpOptions: string[] = Array.from({ length: ((-1.00 - (-8.00)) / 0.50) + 1 }, (_, index) => -8.00 + (0.50 * index))
    .map(n => n.toFixed(2)).filter(tp => {
    const product = getProductById(lens.productId);
    if (product?.itemCode === "17300") {
      return parseFloat(tp) <= -4.50 && parseFloat(tp) >= -8.00;
    }
    if(isLensOrdered) {
      return !(lens.fc === "39.00" && ["-7.00", "-7.50", "-8.00"].includes(tp))
      && !(lens.fc === "39.50" && ["-7.50", "-8.00"].includes(tp))
      && !(lens.fc === "40.00" && tp === "-8.00")
    }
    return true;
  });

  tpOptions.sort((a, b) => Math.abs(parseFloat(a)) - Math.abs(parseFloat(b)));

  const cylOptions: string[] = Array.from({ length: ((3.00 - 1.00) / 0.50) + 1 }, (_, index) => 1.00 + (0.50 * index))
  .map(n => n.toFixed(2));
  const diaOptions: string[] = Array.from({ length: ((11.00 - 10.20) / 0.40) + 1 }, (_, index) => 10.20 + (0.40 * index))
  .map(n => n.toFixed(1));

  const handleLensDataChange = (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    key: 'fc' | 'tp' | 'cyl' | 'dia' | 'qty'
  ) => {
    const { value } = event.target;
    setLens({...lens, [key]: value});
  };

  const initializeLensData = (eyeType: string, productId: number | undefined)  => {
    setLens({fc: undefined, tp: undefined, cyl: undefined, dia: undefined, qty: 1, eyeType: eyeType, productId: productId}); 
  }

  return (
    <div className="contact-box__option">
      <div className="contact-box__flex">
        <p className="contact-box__desc">{eyeType === 'right' ? "右（R）" : "左（L）"}</p>
        <label className="checkbox-item correct-box__form-check">
          <input
            type="checkbox"
            defaultChecked={isLensOrdered}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setIsLensOrdered(e.target.checked)
              initializeLensData(eyeType, productId)
            }}
            id="checkboxhide"
          />
          <span className="checkmark"></span> 注文する </label>
      </div>
      <div className="stockout-message">
        {stockOut && (
          <p className="stockout-alert" style={{color: 'red', fontSize: '1.4rem'}}>{stockOut}</p>
        )}
      </div>
      {isLensOrdered &&
        <div id="hide-content">
          <ul className="select-list">
            <LensSelect label={"FC"} options={fcOptions} value={lens.fc || ''} onChange={(e) => handleLensDataChange(e, 'fc')} />
            <LensSelect label={"TP"} options={tpOptions} value={lens.tp || ''} onChange={(e) => handleLensDataChange(e, 'tp')} />
            {isAstigma && <LensSelect label={"CYL"} options={cylOptions} value={lens.cyl || ''} onChange={(e) => handleLensDataChange(e, 'cyl')} /> }
            <LensSelect label={"DIA"} options={diaOptions} value={lens.dia || ''} onChange={(e) => handleLensDataChange(e, 'dia')} />
          </ul>
          <ul className="select-list">
            <li className="select-list__item">
              <span>数量</span>
              <span style={{paddingLeft: '10px'}}>1</span>
            </li>
          </ul>
        </div>
      }
    </div>
  )
}
